import { HTTPError } from "../../Exceptions/HTTPError";
import LoaderOverlay from "../LoaderOverlay";
import { Toast } from "../../Components/Dialog/Toast";
import Confetti from "./Confetti";
import { CONFETTI_OPTIONS, JOB_APPLICATION } from "./Constants";

class JobApplication {
    private readonly form: HTMLFormElement;
    private readonly submitButton: HTMLButtonElement;
    private readonly cancelButton: HTMLButtonElement;
    private readonly confetti = new Confetti(CONFETTI_OPTIONS.count, CONFETTI_OPTIONS.defaults);

    constructor(form: HTMLFormElement) {
        this.form = form;
        this.submitButton = this.form.querySelector<HTMLButtonElement>(JOB_APPLICATION.SELECTORS.submitButton);
        this.cancelButton = this.form.querySelector<HTMLButtonElement>(JOB_APPLICATION.SELECTORS.cancelButton);

        this.initListeners();
    }

    initListeners() {
        this.submitButton.addEventListener("click", this.submit.bind(this));
        this.cancelButton.addEventListener("click", this.cancel.bind(this));
    }

    private async submit(e: Event) {
        const formData = new FormData(this.form);
        if (this.form.checkValidity() === true) {
            e.preventDefault();
            const loaderOverlay = new LoaderOverlay().render();
            this.submitButton.disabled = true;

            try {
                await this.postData(formData);
                this.confetti.render();

                new Toast({
                    title: window.SuccessMessages.purchaseRequest.success,
                    type: Toast.TYPE_SUCCESS
                })?.render();

                this.form.reset();
                this.cancel();
            } catch (e) {
                console.error(e);

                new Toast({
                    title: window.SuccessMessages.purchaseRequest.error,
                    type: Toast.TYPE_ERROR
                })?.render();
            } finally {
                loaderOverlay.destroy();
                this.submitButton.disabled = false;
            }
        }
    }

    private async postData(data: FormData) {
        const response = await fetch(JOB_APPLICATION.FORM_ACTION, {
            method: "POST",
            body: data
        });

        if (response.status !== 200) {
            throw new HTTPError(response.status, response.statusText);
        }

        return response.json();
    }

    private cancel = () => {
        const headerHeight = document.querySelector<HTMLElement>("body > header").offsetHeight;
        const top = this.form.parentElement.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ behavior: "smooth", top: top, left: 0 });
    };
}

const jobApplicationForm = document.querySelector<HTMLFormElement>(JOB_APPLICATION.SELECTORS.form);
if (jobApplicationForm) {
    new JobApplication(jobApplicationForm);
}
